import classNames from 'classnames';
import Chip from './Chip';

const ChipContainer = ({data, remove, color, className}) => {
  if (!data.length) return;

  return (
    <div className={classNames('flex flex-wrap gap-2', className)}>
      {data.map((item, idx) => (
        <Chip key={idx} remove={remove} color={color} item={item} />
      ))}
    </div>
  );
};

export default ChipContainer;
